<template>
  <div>
    <!-- Floating Button for small screens -->
    <button
      class="btn btn-secondary rounded-circle position-absolute top-0 start-0 m-3 d-lg-none"
      style="width: 48px; height: 48px; z-index: 1001"
      @click="toggleMobilePanel"
      ref="mobileToggleBtn"
      aria-label="Toggle map tools"
    >
      <i class="bi bi-tools"></i>
    </button>

    <!-- Mobile compact panel -->
    <div
      v-if="mobileOpen"
      class="position-absolute top-0 start-0 m-3 bg-white rounded shadow-sm d-lg-none border"
      style="width: 240px; z-index: 1002"
      @click.stop
      ref="mobilePanel"
    >
      <div
        class="bg-light p-3 border-bottom d-flex justify-content-between align-items-center"
      >
        <h2 class="mb-0 h6">Map Tools</h2>
        <button
          type="button"
          class="btn-close"
          @click="toggleMobilePanel"
          aria-label="Close"
        ></button>
      </div>
      <ToolsPanelContent
        :zoom-to-selected="mapSettings.zoomToSelected"
        :assigned-island-id="assignedIslandId"
        id-suffix="-sm"
        @toggleZoom="handleZoomToggle"
        @goToAssignedIsland="handleGoToAssignedIsland"
      />
    </div>

    <!-- Desktop/full panel -->
    <div
      class="position-absolute top-0 start-0 m-3 bg-white rounded shadow-sm d-none d-lg-block border"
      style="width: 200px; z-index: 1000"
    >
      <div class="bg-light p-3 border-bottom">
        <h2 class="mb-0 h5">Map Tools</h2>
      </div>
      <ToolsPanelContent
        :zoom-to-selected="mapSettings.zoomToSelected"
        :assigned-island-id="assignedIslandId"
        @toggleZoom="handleZoomToggle"
        @goToAssignedIsland="handleGoToAssignedIsland"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ToolsPanelContent from "./ToolsPanelContent.vue";

export default {
  name: "MapToolsPanel",
  components: { ToolsPanelContent },
  data() {
    return {
      mobileOpen: false
    };
  },
  mounted() {
    document.addEventListener("click", this.handleGlobalClick, true);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleGlobalClick, true);
  },
  computed: {
    ...mapGetters(["mapSettings", "selectedItem", "assignedIslandId"])
  },
  methods: {
    ...mapActions(["toggleZoomToSelected"]),
    toggleMobilePanel() {
      this.mobileOpen = !this.mobileOpen;
    },
    handleGlobalClick(event) {
      if (!this.mobileOpen) return;
      const panel = this.$refs.mobilePanel;
      const button = this.$refs.mobileToggleBtn;
      if (!panel || !button) {
        this.mobileOpen = false;
        return;
      }
      const target = event.target;
      const clickedInsidePanel = panel.contains(target);
      const clickedButton = button.contains(target);
      if (!clickedInsidePanel && !clickedButton) {
        this.mobileOpen = false;
      }
    },
    handleZoomToggle(enabled) {
      this.toggleZoomToSelected(enabled);

      // If toggling ON and there's a currently selected item, trigger zoom immediately
      if (enabled && this.selectedItem) {
        this.$emit("zoomToCurrentSelection");
      }
    },
    handleGoToAssignedIsland() {
      this.$emit("goToAssignedIsland");
    }
  }
};
</script>

<style scoped>
/* All styling is now handled by Bootstrap utility classes */
</style>
